/* Please ❤ this and follow me if you like it! */

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license
(function () {
    let lastTime = 0;
    const vendors = ['webkit', 'moz', 'ms', 'o'];
    for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame =
            window[vendors[x] + 'CancelAnimationFrame'] ||
            window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback, element) {
            const currTime = new Date().getTime();
            const timeToCall = Math.max(0, 16 - (currTime - lastTime));
            const id = window.setTimeout(function () {
                callback(currTime + timeToCall); // eslint-disable-line
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
})();

(function () {
    // const html = document.documentElement;
    const stage = document.querySelector('[data-christmas="root"]');

    function Snowflake (maxX) {
        this.reset(maxX);
    }

    Snowflake.prototype.tick = function () {
        let sidePhase = (this.sidePhase += this.sideVel); // eslint-disable-line
        this.y += this.vel;
        this.x += this.sideVel;
    };
    Snowflake.prototype.reset = function (maxX) {
        let rand = Math.random(); // eslint-disable-line
        const chanceOfLargeSnowflake = 0.15;

        this.size = Math.random();
        this.vel = 2 + Math.random() * 3;

        if (this.size < chanceOfLargeSnowflake) {
            this.size += 2;
        } else {
            this.size += 0.5;
            this.vel *= 0.8;
        }

        this.alpha = 0.5 + Math.random() * 0.8;

        // random x position
        this.x = Math.random() * maxX;
        this.y = -this.size;

        // side-to-side movement
        this.sideVel = (0.5 - Math.random()) * this.vel;

        return this;
    };

    (function () {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const settleCanvas = document.createElement('canvas');
        const settleContext = context && settleCanvas.getContext('2d');
        let windowResized;
        const activeFlakes = [];
        const snowflakesPerPixelPerSecond = 0.1;
        const PIx2 = Math.PI * 2;
        const assumedFps = 60;
        let settlePoint;
        const snowflakePool = [];

        function resizeCanvas () {
            settlePoint = Array(stage.clientWidth);
            settleCanvas.width = canvas.width = stage.clientWidth;
            settleCanvas.height = canvas.height = stage.clientHeight;
        }

        function updateSettlePoints (flake) {
            const size = flake.size * 0.8; // reduce coral effect
            let xStart = Math.floor(flake.x - size);
            let range = size * 2;
            let newY;

            if (xStart < 0) {
                range += xStart;
                xStart = 0;
            }
            if (xStart + range > settlePoint.length) {
                range -= xStart + range - settlePoint.length;
            }

            for (let i = 0; i < range; i++) {
                newY = flake.y - size * Math.cos((i / range) * Math.PI - Math.PI / 2);
                settlePoint[i + xStart] = Math.min(
                    settlePoint[i + xStart] || Infinity,
                    newY
                );
            }
        }

        let flakesToCreate = 0;

        function frame () {
            flakesToCreate += (snowflakesPerPixelPerSecond / assumedFps) * canvas.width;
            let flakesThisFrame = Math.floor(flakesToCreate);
            flakesToCreate -= flakesThisFrame;

            // clear canvas
            if (windowResized) {
                resizeCanvas();
                windowResized = false;
            } else {
                context.clearRect(0, 0, canvas.width, canvas.height);
            }

            // add new flake?
            while (flakesThisFrame--) {
                if (snowflakePool.length) {
                    activeFlakes.push(snowflakePool.pop().reset(canvas.width));
                } else {
                    activeFlakes.push(new Snowflake(canvas.width));
                }
            }

            let i = activeFlakes.length;
            let flake;

            // for each flake...
            while (i--) {
                flake = activeFlakes[i];
                flake.tick();

                // splice flake if it's now out of rendering zone
                if (
                    flake.y >= canvas.height ||
                    flake.y >= settlePoint[Math.floor(flake.x)]
                ) {
                    snowflakePool.push.apply(snowflakePool, activeFlakes.splice(i, 1));
                    // this flake effects our settle points
                    if (flake.alpha > 0.8) {
                        updateSettlePoints(flake);
                    }
                    settleContext.fillStyle = 'rgba(255, 255, 255, ' + flake.alpha + ')';
                    settleContext.beginPath();
                    settleContext.arc(flake.x, flake.y, flake.size, 0, PIx2, true);
                    settleContext.closePath();
                    settleContext.fill();
                    continue;
                }

                // render to canvas
                context.fillStyle = 'rgba(255, 255, 255, ' + flake.alpha + ')';
                context.beginPath();
                context.arc(flake.x, flake.y, flake.size, 0, PIx2, true);
                context.closePath();
                context.fill();
            }
            requestAnimationFrame(frame);
        }

        if (context) {
            // watch out for resizes
            window.addEventListener(
                'resize',
                function () {
                    windowResized = true;
                },
                false
            );

            // add it to the page & start animating
            canvas.id = 'context-canvas';
            settleCanvas.id = 'settle-canvas';
            stage.appendChild(canvas);
            stage.appendChild(settleCanvas);
            requestAnimationFrame(frame);

            resizeCanvas();
        }
    })();
})();
